import React, { useMemo } from "react";
import { get } from "lodash";
import { required } from "react-admin";
import { useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import { DebouncedTextInput } from "ra-friendsofbabba";

const CustomCategoryInput = (props) => {
  const form = useFormState();
  const { categories, subcategories } = useSelector((state) => ({
    categories: Object.values(
      get(state, "admin.resources.doc-categories.data", [])
    ),
    subcategories: Object.values(
      get(state, "admin.resources.doc-subcategories.data", [])
    ),
  }));
  const categoryId = get(form, "values.category_id", 0);
  const subcategoryId = get(form, "values.subcategory_id", 0);
  const showCustomCategory = useMemo(() => {
    if (categoryId === 0) {
      return false;
    }
    const category = categories.find((cat) => cat.id === categoryId);
    if (category && category.is_custom) {
      return true;
    }
    if (subcategories.length > 0 && subcategoryId === 0) {
      return false;
    }
    const subcategory = subcategories.find(
      (subcat) => subcat.id === subcategoryId
    );
    if (subcategory && subcategory.is_custom) {
      return true;
    }
    return false;
  }, [categoryId, subcategoryId, categories, subcategories]);

  if (!showCustomCategory) {
    return null;
  }

  return (
    <DebouncedTextInput {...props} maxLength={100} validate={required()} />
  );
};

export default CustomCategoryInput;
